import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import React from 'react';

const StyledBox = styled(Box)({
  width: '100%',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  '.circle': {
    display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		content: '""',
		background: '#888',
		width: 'min(30vw, 30vh)',
		height: 'min(30vw, 30vh)',
		borderRadius: 'min(15vw, 15vh)',
		lineHeight: 'min(15vw, 15vh)',
		animationName: 'loading-pulse',
		animationDuration: '2s',
		animationIterationCount: 'infinite',
		animationDirection: 'alternate',
  },
  '.text': {
    fontSize: 'max(200%, min(4vw, 4vh))',
  },
  '@keyframes loading-pulse': {
    from: {
      boxShadow: '0 0 0 2em #aaa',
    },
    to: {
      boxShadow: '0 0 1em 4em #aaa',
    },
  },
});

const Loading = () => {
  return (
    <StyledBox role="status" aria-live="polite">
      <div className="circle">
        <span className="text">Lädt …</span>
      </div>
    </StyledBox>
  );
};

export default Loading;
